import { renderProposalProgressChart } from "../charts/proposal_progress_chart"

export const ProposalProgressChart = {
  mounted() {
    const chartData = this.el.dataset.chartData
    if (chartData) {
      this.chartData = JSON.parse(chartData)
      this.currencySymbol =
        this.el.dataset.currencySymbol || this.chartData.currency_symbol || ""
      this.areaUnit = this.el.dataset.areaUnit || this.chartData.area_unit || ""
      this.initChart()
    }

    this.handleEvent("select_proposal", ({ proposal_id }) => {
      this.updateSelection(proposal_id)
    })
  },

  updated() {
    const chartData = this.el.dataset.chartData
    if (chartData) {
      this.chartData = JSON.parse(chartData)
      this.currencySymbol =
        this.el.dataset.currencySymbol || this.chartData.currency_symbol || ""
      this.areaUnit = this.el.dataset.areaUnit || this.chartData.area_unit || ""
      this.initChart()
    }
  },

  initChart() {
    if (this.chart) {
      this.chart.destroy()
    }

    const hook = this
    const options = {
      currencySymbol: this.currencySymbol,
      areaUnit: this.areaUnit,
      rootScale: this.el.dataset.rootScale || "main",
    }

    this.chart = renderProposalProgressChart(
      this.el,
      this.chartData,
      {
        onPointClick: (proposalId) => {
          hook.chartData.selected_proposal_id = proposalId
          hook.updateSelection(proposalId)
          hook.pushEvent("view_proposal_details", { id: proposalId.toString() })
        },
        onLoad: (chart) => {
          if (hook.chartData.selected_proposal_id) {
            setTimeout(
              () => hook.updateSelection(hook.chartData.selected_proposal_id),
              0,
            )
          }
        },
        onRedraw: () => {
          if (hook.chartData?.selected_proposal_id) {
            hook.updateSelection(hook.chartData.selected_proposal_id)
          }
        },
      },
      options,
    )
  },

  updateSelection(proposalId) {
    if (!this.chart || !this.chartData) return

    const selectedId = proposalId?.toString()
    this.clearSelection()

    if (!selectedId) return

    let selectedPoint = null
    this.chart.series.forEach((series) => {
      if (series.type === "columnrange") return
      series.points.forEach((point) => {
        if (point.options.proposal_id?.toString() === selectedId) {
          selectedPoint = point
        }
      })
    })

    if (selectedPoint) {
      this.drawSelectionRect(selectedPoint)
    }
  },

  drawSelectionRect(point) {
    this.clearSelection()

    if (!point) return

    if (point.graphic) {
      this.originalMarkerRadius = point.graphic.attr("r")
      point.graphic.attr({ r: 8 })
    }

    if (point.dataLabel && point.dataLabel.div) {
      const labelDiv = point.dataLabel.div.querySelector("div")
      if (labelDiv) {
        labelDiv.style.backgroundColor = "rgba(61, 198, 195, 0.15)"
        labelDiv.style.padding = "4px 8px"
        labelDiv.style.borderRadius = "4px"
        labelDiv.style.border = "1px solid rgba(61, 198, 195, 0.4)"
        this.selectedLabelDiv = labelDiv
      }
    }

    this.selectedPoint = point
  },

  clearSelection() {
    if (this.selectedPoint?.graphic && this.originalMarkerRadius) {
      this.selectedPoint.graphic.attr({ r: this.originalMarkerRadius })
    }

    if (this.selectedLabelDiv) {
      this.selectedLabelDiv.style.backgroundColor = ""
      this.selectedLabelDiv.style.padding = ""
      this.selectedLabelDiv.style.borderRadius = ""
      this.selectedLabelDiv.style.border = ""
    }

    this.selectedPoint = null
    this.selectedLabelDiv = null
    this.originalMarkerRadius = null
  },

  destroyed() {
    if (this.chart) {
      this.chart.destroy()
    }
  },
}
